export default "__VITE_ASSET__tDxa0IxD__"